module.exports = __webpack_public_path__ + "static/media/transf6.68226c39.jpg";